export const API_SUCCESS = 'API_SUCCESS';
export const LOADING = 'LOADING';
export const ACCIDENTSLOADED = 'ACCIDENTSLOADED';
export const ACCIDENTSSTATLOADED = 'ACCIDENTSSTATLOADED';
export const BRANCHESLOADED = 'BRANCHESLOADED';
export const ACCIDENTSTRANSFERRED = 'ACCIDENTSTRANSFERRED';
export const ACCIDENTSREPORTLOADED = 'ACCIDENTSREPORTLOADED';
export const CLAIMSLISTSLOADED = 'CLAIMSLISTSLOADED';
export const MODELSLOADED = 'MODELSLOADED';
export const SUBMODELSLOADED = 'SUBMODELSLOADED';
export const SUBMODELSSTYLEANDBODYLOADED = 'SUBMODELSSTYLEANDBODYLOADED';
export const GARAGESLOADED = 'GARAGESLOADED';
export const VEHICLEADDEDTOACCIDENT = 'VEHICLEADDEDTOACCIDENT';
export const USERSLOADED = 'USERSLOADED';
export const PARTYADDEDTOACCIDENT = 'PARTYADDEDTOACCIDENT';
export const PATIENTSADDEDTOACCIDENT = 'PATIENTSADDEDTOACCIDENT';
export const ACCIDENTREPORTLOADED = 'ACCIDENTREPORTLOADED';
export const CLAIMSBYLICENSERELOADED = 'CLAIMSBYLICENSERELOADED';
export const INVESTIGATIONREPORTADDED = 'INVESTIGATIONREPORTADDED';